import type { NextPage } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import dynamic from 'next/dynamic';
import React from 'react';

import PageNextJs from 'nextjs/PageNextJs';

const VerifiedContracts = dynamic(() => import('ui/pages/VerifiedContracts'), { ssr: false });

const Page: NextPage = () => {
  return (
    <PageNextJs pathname="/verified-contracts">
      <VerifiedContracts/>
    </PageNextJs>
  );
};

export default Page;

export const getServerSideProps = async(ctx: { locale: string }) => {
  return {
    props: {
      ...(await serverSideTranslations(ctx.locale || 'en', [ 'common' ])),
    },
  };
};
